import React from "react";

function ViewBlog({ data }) {
  if (!data) return null;

  return (
    <div className="custom-modal-body">
      <div className="model-custum">

        {/* IMAGE */}
        <div className="view-blog-image">
          <img
            src={data?.front_blog_image || data?.blogimage}
            alt={data?.title}
          />
        </div>

        {/* TITLE */}
        <h3>{data?.title}</h3>

        {/* STATUS */}
        <div
          className={
            data?.status === "active"
              ? "view-status-badge published-badge"
              : "view-status-badge draft-badge"
          }
        >
          {data?.status}
        </div>

        {/* DETAILS GRID */}
        <div className="view-details-grid">

          <div className="view-detail-card">
            <span>Category ID</span>
            <h5>{data?.category_id}</h5>
          </div>

          <div className="view-detail-card">
            <span>Subtitle</span>
            <h5>{data?.subtitle}</h5>
          </div>

          <div className="view-detail-card">
            <span>Slug</span>
            <h5>{data?.slug}</h5>
          </div>

          <div className="view-detail-card">
            <span>Sub Heading</span>
            <h5>{data?.sub_heading}</h5>
          </div>

          <div className="view-detail-card">
            <span>Location</span>
            <h5>{data?.location}</h5>
          </div>

          <div className="view-detail-card">
            <span>Date</span>
            <h5>{data?.date}</h5>
          </div>

          <div className="view-detail-card">
            <span>Meta Title</span>
            <h5>{data?.meta_title}</h5>
          </div>

          <div className="view-detail-card">
            <span>Meta Keywords</span>
            <h5>{data?.meta_keywords}</h5>
          </div>

          <div className="view-detail-card">
            <span>Meta Description</span>
            <h5>{data?.meta_description}</h5>
          </div>

        </div>

        {/* DESCRIPTION (HTML SAFE) */}
        <div className="view-description mt-3">
          <span>Description</span>

          <div
            dangerouslySetInnerHTML={{
              __html: data?.description,
            }}
          />
        </div>

        {/* EXTRA IMAGES (if backend gives array) */}
        {data?.description_images?.length > 0 && (
          <div className="view-extra-images mt-3">
            <span>Gallery</span>

            <div className="d-flex gap-2 flex-wrap">
              {data.description_images.map((img, i) => (
                <img
                  key={i}
                  src={img}
                  alt={`desc-${i}`}
                  width="80"
                  height="80"
                  style={{ objectFit: "cover", borderRadius: "6px" }}
                />
              ))}
            </div>
          </div>
        )}

      </div>
    </div>
  );
}

export default ViewBlog;